import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {activeItemOtherProducts} from "../../ducks/content";
import ProductCards from "../../../common/ProductCards";

function OtherProducts({otherProducts}) {
  return (
    <ProductCards
      title="Другие товары этого раздела"
      products={otherProducts}
    />
  );
}

OtherProducts.propTypes = {
  otherProducts: PropTypes.array
};

export default connect((state) => ({
  otherProducts: activeItemOtherProducts(state)
}))(OtherProducts);
